import Input from '@/Components/Inputs/Input';
import { useForm } from '@inertiajs/react';
import { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FormSignUp = ({ inviteeEmail, inviteeName }) => {
  const [success, setSuccess] = useState(false);
  const [active, setActive] = useState(false);

  const emailRef = useRef(null);
  const fullNameRef = useRef(null);

  const form = useForm({
    full_name: inviteeName,
    email: inviteeEmail,
  });

  const handleSubmit = e => {
    e.preventDefault();
    form.post(route('newsletter.process'), {
      errorBag: 'newsletter',
      preserveScroll: true,
      onSuccess: () => {
        form.reset();
        setActive(false);
        setSuccess(true);
      },
      onError: errors => {
        if (errors.email) {
          emailRef.current.focus();
        }
        if (errors.full_name) {
          fullNameRef.current.focus();
        }
      },
    });
  };

  return (
    <>
      {!inviteeName && (
        <p className="mt-8 mb-2 w-full text-center font-medium text-grey">
          Sign up to our monthly newsletter
        </p>
      )}

      {success ? (
        <p className="mt-8 w-full text-center font-medium">
          Thank you, you've been successfully signed up!
        </p>
      ) : (
        <form
          onSubmit={e => handleSubmit(e)}
          className="grid gap-x-4 md:grid-cols-2"
        >
          <Input
            label="Enter your full name"
            id="full_name"
            type="text"
            required
            value={form.data.full_name}
            onFocus={e => {
              active == false && setActive(true);
            }}
            onChange={e => {
              form.errors.full_name && form.clearErrors('full_name');
              form.setData('full_name', e.currentTarget.value);
            }}
            ref={fullNameRef}
            error={form.errors.full_name}
          />
          <Input
            label="Enter your email"
            id="email"
            type="email"
            required
            value={form.data.email}
            onFocus={e => {
              active == false && setActive(true);
            }}
            onChange={e => {
              form.errors.email && form.clearErrors('email');
              form.setData('email', e.currentTarget.value);
            }}
            ref={emailRef}
            error={form.errors.email}
          />
          <button
            type="submit"
            className="col-span-full w-full rounded-button bg-primary py-3.5 text-dark duration-mini hover:opacity-90"
            disabled={form.processing}
          >
            <p className="w-full">Subscribe 📨</p>
          </button>
          <p className="col-span-full mt-3.5 text-xs text-gray-500">
            By submitting this form, you are agreeing to receive marketing
            emails from madeby.studio Ltd. You can unsubscribe at any time. We
            process your data in accordance to our{' '}
            <a
              className="underline"
              href="https://madeby.studio/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </p>
        </form>
      )}
      {inviteeName && (
        <hr className="border-0.5 my-8 w-full border-gray-300"></hr>
      )}
    </>
  );
};

export default FormSignUp;
